<template lang="pug">
.waiter-detail-tab(v-cloak)
  .mb-3
  .template-container.ml-2(v-if="value && waiterViewableFacilitiesMap && waiterLoaded")
    .information.mb-2(v-if="value.waiter.admissionApplication.information" style="white-space: pre-wrap; word-wrap: break-word;") 
      span {{ value.waiter.admissionApplication.information }}

    .template(v-for="(property, index) in value.waiter.admissionApplication.templateAnswer.properties")
      WaiterTemplateItem(v-model="value.waiter.admissionApplication.templateAnswer.properties[index]" :waiterViewableFacilitiesMap="waiterViewableFacilitiesMap" :isChaild="false")
</template>

<script lang="ts">
import { Component, Prop, Watch, Vue } from "vue-property-decorator";

import { ResidentGetModel } from "@/commons/services/Residents";
import { FacilityGetModel } from "@/commons/services/Facilities";

import WaiterTemplateItem from "@/pc/containers/waiters/WaiterTemplateItem.vue";

/**
 * ### 待機者詳細タブコンポーネント
 */
@Component({
  components: {
    WaiterTemplateItem
  }
})
export default class WaiterDetailTab extends Vue {
  /** 利用者 */
  @Prop()
  value!: ResidentGetModel;

  @Prop()
  waiterViewableFacilitiesMap!: Map<number, FacilityGetModel>;

  /** 待機者情報が全て読み込まれたか否か */
  waiterLoaded: boolean = false;

  @Watch("value", { immediate: true })
  public async watchValue(newValue: ResidentGetModel): Promise<void> {
    if (newValue && !this.waiterLoaded) {
      this.waiterLoaded = true;
    }
    return;
  }

  /**
   * ### vue lifecycle created
   */
  public async mounted(): Promise<void> {
    return;
  }
}
</script>

<style lang="scss" scoped>
.waiter-detail-tab {
  position: relative;
  width: 100%;
  min-height: 240px;
}
</style>
